import * as Yup from 'yup';

export const BUYER_SITE_TABS = [
  'details',
  'address',
  'contact',
  'linked-supplier-sites',
  'linked-users',
] as const;
export type BuyerSiteTab = (typeof BUYER_SITE_TABS)[number];

export const BuyerSiteSearchParamsSchema = Yup.object({
  tab: Yup.mixed<BuyerSiteTab>()
    .oneOf([...BUYER_SITE_TABS])
    .optional()
    .default('details'),
});
